<template>
    <div>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.environmentTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.locationTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.locationProximityAndSituation')">
                            <el-checkbox
                                    v-model="post.proche_aeroport"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxAirport") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_sortie_autoroute"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxHighwayExit") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_gare"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxGare") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_bus" true-label="oui" false-label="non">{{
                                $t("posts.edit.checkboxBus") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_tram"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxTramway") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_parking"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxParking") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_commerces"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxShops") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_centre_commercial"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxMall") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_centre_ville"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxDowntown") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_creche"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxNursery") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_ecole_primaire"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxPrimarySchool") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_college"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxCollege") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_lycee"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxHighSchool") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_universite"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxUniversity") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.espaces_verts"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxGreenSpaces") }}
                            </el-checkbox>
                            <el-checkbox
                                    v-model="post.proche_metro"
                                    true-label="oui"
                                    false-label="non"
                            >{{ $t("posts.edit.checkboxSubway") }}
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.energyTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.chauffage_type}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.chauffage_type != '' && post.chauffage_type != undefined && post.chauffage_type != null"
                                           @click="post.chauffage_type = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.chauffage_type">
                                <el-radio
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_type')"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.chauffage_energie">
                            <el-select
                                    v-model="post.chauffage_energie"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_energie')"
                                        :key="energieChauffageChoice"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <dpe-ges :post="post"></dpe-ges>
        <isolation-thermique-solaire :post="post"></isolation-thermique-solaire>
        <securite-bien :post="post"></securite-bien>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.servicesTitle')">
                <el-row>
                    <el-col :span="12">
                        <el-checkbox v-model="post.ascenseur" true-label="oui" false-label="non">
                            {{$labels.ascenseur}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.placards_integres" true-label="oui" false-label="non">
                            {{$labels.placards_integres}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.garage" true-label="oui" false-label="non">{{$labels.garage}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.possede_parking" true-label="oui" false-label="non">
                            {{$labels.possede_parking}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.possede_box" true-label="oui" false-label="non">
                            {{$labels.possede_box}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.terrasse" true-label="oui" false-label="non">{{$labels.terrasse}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.balcon" true-label="oui" false-label="non">{{$labels.balcon}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.loggia" true-label="oui" false-label="non">{{$labels.loggia}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.cave" true-label="oui" false-label="non">{{$labels.cave}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.digicode" true-label="oui" false-label="non">{{$labels.digicode}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.interphone" true-label="oui" false-label="non">
                            {{$labels.interphone}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.videophone" true-label="oui" false-label="non">
                            {{$labels.videophone}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.gardien" true-label="oui" false-label="non">{{$labels.gardien}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.alarme_habitation" true-label="oui" false-label="non">
                            {{$labels.alarme_habitation}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.volets_roulants_electriques" true-label="oui" false-label="non">
                            {{$labels.volets_roulants_electriques}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.piscine" true-label="oui" false-label="non">{{$labels.piscine}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                      <el-checkbox v-model="post.pieds_dans_eau" true-label="oui" false-label="non">
                        {{ $labels.pieds_dans_eau }}
                      </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.climatise" true-label="oui" false-label="non">{{$labels.climatise}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.tv" true-label="oui" false-label="non">{{$labels.tv}}</el-checkbox>
                    </el-col>
                    <el-col :span="12">
                      <el-checkbox v-model="post.cable_tv" true-label="oui" false-label="non">{{ $labels.cable_tv }}</el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.acces_handicapes" true-label="oui" false-label="non">
                            {{$labels.acces_handicapes}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.terrain_piscinable" true-label="oui" false-label="non">
                            {{$labels.terrain_piscinable}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.est_adapte_pmr" true-label="oui" false-label="non">
                            {{$labels.est_adapte_pmr}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.local_velos" true-label="oui" false-label="non">{{$labels.local_velos}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                      <el-checkbox v-model="post.veranda" true-label="oui" false-label="non">{{ $labels.veranda }}</el-checkbox>
                    </el-col>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item :label="$labels.type_jardin" prop="type_jardin">
                          <el-button class="el-icon-error reset-radio" v-if="post.type_jardin != '' && post.type_jardin != undefined && post.type_jardin != null" @click="post.type_jardin = null" circle></el-button>
                          <el-radio-group v-model="post.type_jardin">
                            <el-radio :label="jardinChoice" :value="jardinChoice" v-for="jardinChoice in this.$parent.getChoices('type_jardin')"></el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" v-if="post.type_jardin == 'privatif'">
                        <el-form-item :label="$labels.surface_jardin" prop="surface_jardin">
                          <el-input v-mask="'#################'" v-model.number="post.surface_jardin" type="surface_jardin">
                            <div slot="append">m²</div>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.vitrages}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.vitrages != '' && post.vitrages != undefined && post.vitrages != null"
                                           @click="post.vitrages = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.vitrages">
                                <el-radio
                                        v-for="natureVitrageChoice in this.$parent.getChoices('vitrages')"
                                        :label="natureVitrageChoice"
                                        :value="natureVitrageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.revetement_sol_principal">
                            <el-select
                                    v-model="post.revetement_sol_principal"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="revetementSolChoice in this.$parent.getChoices('revetement_sol_principal')"
                                        :key="revetementSolChoice"
                                        :label="revetementSolChoice"
                                        :value="revetementSolChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.toiture">
                            <el-select
                                    v-model="post.toiture"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="typeToitureChoice in this.$parent.getChoices('toiture')"
                                        :key="typeToitureChoice"
                                        :label="typeToitureChoice"
                                        :value="typeToitureChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import DpeGes from '../Block/DpeGes'
import IsolationThermiqueSolaire from '../Block/IsolationThermiqueSolaire'
import SecuriteBien from "@/pages/posts/forms/Block/SecuriteBien.vue";

export default {
  name: 'PostEditImmoObject3400',
  props: ['post', 'ddList'],
  components: {SecuriteBien, DpeGes, IsolationThermiqueSolaire },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['residence_type', 'dpe_etiquette_conso', 'dpe_etiquette_ges', 'environnement', 'chauffage_energie', 'chauffage_type', 'revetement_sol_principal', 'vitrages', 'type_jardin', 'mandat_statut', 'modalites_recuperation_charges_locatives']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
